/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGeneratedCalculation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m8.438 8 .568-5h1.988l-.543 5h3.987l.568-5h1.988l-.543 5H21l-.23 2h-4.542l-1.234 11h-1.988l.543-5H9.562l-.568 5H7.006l.543-5H3l.23-2h4.542l.444-4H3l.23-2zm1.79 2-.444 4h3.988l.444-4zM17 18l4-5-1 4 3 1-5 5 2-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGeneratedCalculation as GeneratedCalculation };
